module.exports = __webpack_public_path__ + "img/2.f801d9c8.jpg";